var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNervaAppLogoWithName = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 69,
    viewBox: "0 0 259 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.837 27.0384V49.7258H105.563V27.7741C105.563 24.8789 102.98 22.1023 98.6992 22.1023C94.7294 22.1023 91.8357 24.8789 91.8357 27.7741V49.7258H83.5372V15.671H91.8118V19.8952C93.0792 17.9493 95.1837 15.4812 99.4884 14.9354C105.371 14.1997 113.813 18.4714 113.813 27.0384H113.837Z",
    fill: "#367B6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.126 34.9674H126.705C127.518 40.5443 131.344 43.226 135.242 43.2735C137.849 43.2497 140.408 42.0394 142.058 39.5951H151.098C148.587 46.5959 142.202 50.4641 135.242 50.5116C126.227 50.4404 118.239 44.0092 118.239 32.6655C118.239 21.3218 126.418 14.8193 135.242 14.8193C144.067 14.8193 152.246 21.3455 152.246 32.6655C152.246 33.4486 152.198 34.2318 152.126 34.9674V34.9674ZM143.493 28.726C141.795 24.3594 138.782 22.1287 135.218 22.0812C131.655 22.1287 128.642 24.3594 126.944 28.726H143.493Z",
    fill: "#367B6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.098 15.6731V23.2909C178.098 23.2909 176.496 22.5078 173.53 22.5078C168.747 22.5078 166.26 25.1182 166.26 28.678V49.7279H157.986V15.6731H166.26V20.7991C167.145 18.331 169.943 14.8662 173.53 14.8662C175.132 14.8662 176.663 15.151 178.098 15.6731Z",
    fill: "#367B6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.657 15.6797L204.187 49.7345H189.766L179.985 15.6797H189.073L196.965 45.795L204.57 15.6797H213.657V15.6797Z",
    fill: "#367B6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.32 24.4314V49.6818H237.045V44.5558C236.352 46.5729 233.793 50.2988 228.293 50.4886C219.899 50.7497 215.522 44.6981 215.522 39.2399C215.522 32.2865 221.333 27.9674 228.388 27.9674H233.554C235.634 27.9674 237.141 26.7808 237.045 25.262C236.878 22.699 234.75 21.37 231.258 21.37C228.962 21.37 226.786 22.7702 226.045 24.4789H217.746C219.277 17.4069 225.423 14.7964 231.258 14.7964C237.093 14.7964 245.344 17.7866 245.344 24.4314H245.32ZM237.045 33.2833C235.874 33.7342 234.582 33.9715 233.243 33.9715H229.728C227.551 33.9715 224.179 34.6122 223.797 38.1482C223.486 41.0198 225.877 43.6302 229.728 43.6302C233.386 43.6302 237.045 41.0198 237.045 38.1245V33.2833Z",
    fill: "#367B6E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.777 11.498V12.2812H249.53V18.1192H248.621V12.2812H246.373V11.498H251.777V11.498Z",
    fill: "#367B6E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M252.591 11.498H253.882L255.795 17.0987L257.709 11.498H259V18.1192H258.139V14.2034C258.139 14.0611 258.139 13.8475 258.139 13.539C258.139 13.2305 258.139 12.8982 258.139 12.5422L256.226 18.1429H255.341L253.428 12.5422V12.7558C253.428 12.9219 253.428 13.1593 253.428 13.4915C253.428 13.8237 253.428 14.0611 253.428 14.2272V18.1429H252.567V11.498H252.591Z",
    fill: "#367B6E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5118_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5333C3 6.61136 8.67106 1 15.6667 1H53.6667C60.6623 1 66.3333 6.61136 66.3333 13.5333V51.1333C66.3333 58.0553 60.6623 63.6667 53.6667 63.6667H15.6667C8.67106 63.6667 3 58.0553 3 51.1333V13.5333Z",
    fill: "#367B6E"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8065 37.1559C39.8545 39.5282 34.6335 39.0286 31.2216 35.6482C27.8053 32.2679 27.3003 27.1062 29.6979 23.1958L21.5787 15.1621C13.1961 23.4565 13.1961 36.8996 21.5787 45.1939C29.9613 53.4883 43.5474 53.4883 51.93 45.1939L43.8109 37.1603L43.8065 37.1559Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2186 15.8632C47.2052 11.892 40.7019 11.892 36.6885 15.8632C36.0913 16.4541 35.5819 17.1015 35.1648 17.788C32.7672 21.6984 33.2722 26.8644 36.6885 30.2404C40.1047 33.6207 45.3214 34.1204 49.2734 31.7481C49.9672 31.331 50.6214 30.8313 51.2186 30.2404C55.2321 26.2692 55.2321 19.8344 51.2186 15.8632V15.8632Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5118_411",
    x: 0,
    y: 0,
    width: 69.3333,
    height: 68.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5118_411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5118_411",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNervaAppLogoWithName);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nerva-app-logo-with-name.90060d8ed4eb1cf8953e1bccfdb89486.svg";